import { clientConfigurationUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";
import axios, { isAxiosError } from "axios";
import { buildAxiosAuthenticationHeaders } from "../util/build-axios-authentication-headers";

export interface PostGatewayOnboardPayload {
  onboarding_key: string;
}

export interface PostGatewayOnboardResponse {
  message?: string;
  namespace?: string;
  gateway_id?: string;
  operation_id?: string;
  detail?: string;
}

export const postGatewayOnboard = async (
  namespace: string,
  onboardingKey: string,
) => {
  const url = clientConfigurationUrlEnvVar();
  const headers = buildAxiosAuthenticationHeaders();

  try {
    const response = await axios.post<PostGatewayOnboardResponse>(
      `${url}/api/v3/ns/${namespace}/gateways/onboard`,
      { onboarding_key: onboardingKey } as PostGatewayOnboardPayload,
      { headers },
    );

    return response;
  } catch (err) {
    if (isAxiosError(err)) {
      console.error("Axios error:", err);
      throw err;
    }

    throw new Error("An unexpected error occurred while onboarding gateway.");
  }
};
